export default class API {
    constructor(client) {
        this.client = client
    }

    createRecord(moduleName, options) {
        const requestKey = 'api.createRecord'

        let params = {
            moduleName: moduleName,
            options: options
        }

        return this.client._postMessageWithPromise(requestKey, params)
    }

    fetchRecord(moduleName, options) {
        const requestKey = 'api.fetchRecord'

        let params = {
            moduleName: moduleName,
            options: options
        }

        return this.client._postMessageWithPromise(requestKey, params)
    }

    fetchAll(moduleName, options) {
        const requestKey = 'api.fetchAll'

        let params = {
            moduleName: moduleName,
            options: options
        }

        return this.client._postMessageWithPromise(requestKey, params)
    }

    updateRecord(moduleName, options) {
        const requestKey = 'api.updateRecord'

        let params = {
            moduleName: moduleName,
            options: options
        }

        return this.client._postMessageWithPromise(requestKey, params)
    }

    deleteRecord(moduleName, options) {
        const requestKey = 'api.deleteRecord'

        let params = {
            moduleName: moduleName,
            options: options
        }

        return this.client._postMessageWithPromise(requestKey, params)
    }
}